<template>
  <com-page>
    <com-card>
      <el-descriptions title="订单信息" :column="4">
        <el-descriptions-item label="订单号">{{ detail.number }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{
          detail.createTime | formatDate
        }}</el-descriptions-item>
        <el-descriptions-item label="订单金额">{{ detail.paySum }}</el-descriptions-item>
        <el-descriptions-item label="电费">{{ detail.electricCharge || 0 }}</el-descriptions-item>
        <el-descriptions-item label="服务费">{{ detail.sum }}</el-descriptions-item>
        <el-descriptions-item label="支付方式">
          {{ detail.type === '1' ? '钱包支付' : '月卡支付' }}
        </el-descriptions-item>
        <el-descriptions-item label="网点名称">{{ detail.refStoreName }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">
          <div v-if="detail.endTime">
            {{ detail.endTime | formatDate }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="订单实际金额">{{ detail.paySum }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{
          orderStatus[detail.status]
        }}</el-descriptions-item>
        <el-descriptions-item label="设备号">{{ detail.refDevSn }}</el-descriptions-item>
        <el-descriptions-item label="二维码">{{ detail.refDevLabel }}</el-descriptions-item>
        <el-descriptions-item label="订单时长">{{ detail.duration }}min</el-descriptions-item>
        <el-descriptions-item label="总电量">{{
          detail.powerConsumption || 0
        }}</el-descriptions-item>
        <el-descriptions-item label="订单异常">{{
          detail.status == 4 ? '是' : '否'
        }}</el-descriptions-item>
        <el-descriptions-item label="充电端口">{{ detail.refDevPort }}</el-descriptions-item>
        <el-descriptions-item label="充电功率">{{ detail.power }}w</el-descriptions-item>
        <el-descriptions-item label="电费成本">{{ detail.cost }}</el-descriptions-item>

        <el-descriptions-item label="收费标准">
          {{ detail.planPowerStart || 0 }}w-{{ detail.planPowerEnd || 0 }}w
          {{ detail.price || 0 }} /小时</el-descriptions-item
        >
        <el-descriptions-item label="套餐">
          <div>
            <div v-if="detail.payPlan.autoStop">充满自停</div>
            <div v-else>
              <div v-if="detail.payPlan.sum">{{ detail.payPlan.sum }}元</div>
              <div v-else>{{ detail.payPlan.duration }}小时</div>
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="利润">{{ detail.profit }}</el-descriptions-item>
      </el-descriptions>

      <div class="flex items-center justify-between">
        <el-descriptions title="用户信息" :column="1" class="mtb-30px">
          <el-descriptions-item label="用户ID">{{ detail.refUserNumber }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ detail.refUserPhone }}</el-descriptions-item>
        </el-descriptions>

        <el-descriptions title="退单信息" :column="1" v-if="detail.status === '6'">
          <el-descriptions-item label="退单金额">{{ detail.refundSum }}</el-descriptions-item>
          <el-descriptions-item label="退单时间">{{
            detail.refundTime | formatDate
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div id="chart" ref="myChartRef" style="height: 500px; width: 100%"></div>
    </com-card>
  </com-page>
</template>

<script>
import * as echarts from 'echarts'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      detail: {},
      orderStatus: {
        1: '等待开始',
        2: '进行中',
        3: '已完成',
        4: '异常停止',
        5: '人工关闭',
        6: '退单'
      }
    }
  },
  methods: {
    eChartInit() {
      const myChart = echarts.init(document.getElementById('chart'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['功率']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.detail.date,
          axisLabel: {
            rotate: 45
          }
        },

        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '功率',
            data: this.detail.powers,
            type: 'line'
          }
        ]
      })
      window.onresize = () => {
        // 自适应大小
        myChart.resize()
      }
    }
  },
  created() {
    if (utils.isEmptyObj(this.$route.params)) {
      this.$router.push({ name: 'order-index' })
      return
    }
    this.detail = this.$route.params
    console.log('route :>> ', this.detail)
  },
  mounted() {
    this.eChartInit()
  }
}
</script>

<style lang="scss" scoped></style>
